import { removeNonNumbers } from '@ott/transforms';
import type { Formatter } from '../types';
import { checkIsEmptyDate } from '../../checkIsEmptyDate';

const FULL_YEAR_LENGTH = 4;

export const parseYear = (value: string) => {
  if (checkIsEmptyDate(value)) {
    return '';
  }

  const parsedYear = removeNonNumbers(value);

  // Если вставили полный год
  if (parsedYear.length === FULL_YEAR_LENGTH) {
    return parsedYear.slice(2, FULL_YEAR_LENGTH);
  }

  return parsedYear.slice(0, 2);
};

export const formatYear: Formatter = (value, prevValue, cursor, options) => {
  if ((options.isFocused && value && value.length <= 4) || !value) {
    return { value, cursor };
  }

  const parsedYear = removeNonNumbers(value);

  return { value: parsedYear, cursor: parsedYear.length };
};
